export default __webpack_public_path__ + "static/media/the_pulse_tile_cover_mobile.bb3901ba.png";